'use strict';

import React from 'react';
import flux from 'utils/flux';
import Immutable from 'immutable';
import QuotaWarning from 'components/quota/quotaWarning';
import InstantDownloadItem from 'components/modals/instantDownloadItem';
import store from 'store';

var InstantDownloadAllModal = React.createClass({

    displayName: 'InstantDownloadAllModal',


    propTypes: {
        media: React.PropTypes.object
    },

    toggleCheck(fileId, item, e) {
        e.preventDefault();
        flux.getActions('modals').setSelectedItemId(item.id);
        flux.getActions('modals').toggleDownloadAll(fileId);
    },


    checkFilesOfType(fileKey, e) {
        e.preventDefault();
        var elements = e.currentTarget.form;
        for (let i = 0, element; element = elements[i++];) {
            if (element.id == e.currentTarget.control.id) {
                element.checked = !element.checked;
                flux.getActions('modals').setSelectedForFileKey(fileKey, element.checked);
                break;
            }
        }
    },

    areAllFilesOfTypeChecked(fileKey) {
        let items = this.props.media.toJS();
        let allChecked = true;
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            item.files.forEach(file => {
                if (file.key == fileKey) {
                    allChecked &= file._selected;
                }
            });
        }
        return allChecked;
    },

    handleDownload(e) {
        e.preventDefault();
        flux.getActions('modals').generateDownload();
    },

    handleOnSubmit(e) {
        e.preventDefault();

        const assets = this.props.media.toJS();
        let params = {};

        for (let i = 0; i < assets.length; i++) {
            var asset = assets[i];
            asset.files.forEach(file => {
                if (!file._selected) {
                    return;
                }

                if (!params[asset.id]) {
                    params[asset.id] = file.key;
                } else {
                    params[asset.id] += `,${file.key}`;
                }
            });
        }

        flux.getStore('media').checkQuota(params).then(response => {
            const {quotaExceeded} = flux.getStore('media').getState();

            if (quotaExceeded) {
                return false;
            }

            this.refs.download.getDOMNode().submit();

            asset.requires_watermark && flux.getActions('modals').openWatermarkModal(Immutable.List([asset]));
            flux.getActions('modals').closeModals();
        });
    },


    render() {
        if (!this.props.media) {
            return false;
        }

        let items = this.props.media.toJS();
        let mediaboxToken = store.get('mediabox_token');

        let totalSelected = items.filter(item => {
                return item.files.filter(file => file._selected).length > 0;
        });

        var flags = {};
        var uniqueFiles = [];
        for (var i = 0;i < items.length; i++) {
            var item = items[i];
            for (var y = 0;y < item.files.length;y++) {
                var file = item.files[y];
                if (flags[file.key]) continue;
                flags[file.key] = true;
                uniqueFiles.push(file);
            }
        }

        const {quotaExceeded} = this.props;
        return (
            <div>
                <h4>{flux.t('instant_download')}</h4>
                <div className="modal__title">
                    <form>
                        <div className="title_element">
                            <span className="selection__title">
                                {flux.t('select_all')}:
                                </span>
                        </div>

                    {uniqueFiles.map((file, ix) => {
                        return (
                            <div className="title_element">
                                <div key={'basket_size_' + ix}
                                    className="field__checkbox download__checkbox">
                                    <input id={'checkbox_' + ix}
                                        checked={this.areAllFilesOfTypeChecked(file.key)}
                                        type="checkbox" />
                                    <label onClick={this.checkFilesOfType.bind(null, file.key)}
                                        htmlFor={'checkbox_' + ix}>{file.name}</label>
                                </div>
                            </div>
                        );
                    })}
                        <div className="title_element">
                            <button form='downloadForm' type="submit" type="submit" disabled={totalSelected.length === 0 || quotaExceeded}
                                className="btn btn-border selection__download submit__instantdownload">
                                <i className="download" />
                                {flux.t('download')}
                            </button>
                        </div>
                    </form>
                </div>

                <form id="downloadForm" ref="download" onSubmit={this.handleOnSubmit} action={window.config.baseUrl + '/download'} method="post">
                    <input type="hidden" name="token" value={mediaboxToken} />
                    <QuotaWarning />

                    {this.props.media.map((mediaItem) => {
                        return <InstantDownloadItem media={mediaItem} toggleCheck={this.toggleCheck} />
                        })}


                    <div className="instantdownload__footer">

                        <button type="submit" disabled={totalSelected.length === 0 || quotaExceeded}
                            className="btn btn-border selection__download submit__instantdownload">
                            <i className="download" />
                            {flux.t('download')}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
});

module.exports = InstantDownloadAllModal;



// WEBPACK FOOTER //
// ./app/components/modals/instantDownloadAllModal.jsx